// client/src/services/projectService.ts
import { apiRequest } from '@/lib/queryClient';
import { ProjectPayload } from '@shared/interfaces/projectPayload.interface.ts';

export interface FetchProjectsParams {
  page?: number;
  pageSize?: number;
  search?: string;
  clients?: string[];
  owner?: string;
  status?: string;
  sort?: 'recent' | 'alphabetical' | 'completion';
  includeFilters?: boolean;
}

export const fetchProjects = async (params: FetchProjectsParams = {}) => {
  const {
    page,
    pageSize,
    search,
    clients,
    owner,
    status,
    sort,
    includeFilters,
  } = params;

  const query = new URLSearchParams();

  if (typeof page === 'number' && Number.isFinite(page)) {
    query.set('page', String(page));
  }

  if (typeof pageSize === 'number' && Number.isFinite(pageSize)) {
    query.set('pageSize', String(pageSize));
  }

  if (search && search.trim().length > 0) {
    query.set('search', search.trim());
  }

  if (clients && clients.length > 0) {
    query.set('clients', clients.join(','));
  }

  if (owner) {
    query.set('owner', owner);
  }

  if (status) {
    query.set('status', status);
  }

  if (sort) {
    query.set('sort', sort);
  }

  if (includeFilters === false) {
    query.set('includeFilters', 'false');
  }

  const queryString = query.toString();
  const url = queryString ? `/api/projects?${queryString}` : '/api/projects';

  return await apiRequest(url);
};

export const createProject = async (payload: ProjectPayload) => {
  return await apiRequest('/api/projects', { method: 'POST', body: payload });
};

export const updateProject = async (projectId: string, payload: ProjectPayload) => {
  return await apiRequest(`/api/projects/${projectId}`, { method: 'PUT', body: payload });
};

export const deleteProject = async (projectId: string) => {
  return await apiRequest(`/api/projects/${projectId}`, { method: 'DELETE' });
};